import React from 'react';
import _ from 'lodash';

import { useSingleOrderRecordNavigatorQuery } from 'generated/graphql';



export interface IRecord {
  id: string;
  recordNumber: string;
}
export interface IData {
  orderNumber: string;
  records: IRecord[];
}

export function useQuery(orderId: string) {
  const tuple = useSingleOrderRecordNavigatorQuery({
    variables: {
      orderId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        orderNumber: tuple.data?.orderLite?.orderNumber ?? '',
        records: _.map(tuple.data?.orderLite?.returnAuthorizations, (auth): IRecord => ({
          id: auth.id,
          recordNumber: auth.returnNumber
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
